import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=06f8936b&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=06f8936b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8936b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f8936b')) {
      api.createRecord('06f8936b', component.options)
    } else {
      api.reload('06f8936b', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=06f8936b&scoped=true&", function () {
      api.rerender('06f8936b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4dv7gdcxsWW8y/JS/comp/Paginate.vue"
export default component.exports